//#region IMPORT
import React, { useEffect, useState } from 'react';
import { Dialog, Button } from '../../../../Components/MUIs';
import { Box, Typography, TextField } from '@mui/material';
import { Undo as UndoIcon } from '@mui/icons-material';
//#endregion

/**
 * 결재 반려 — 사유 입력 후 API 호출 (부모 onConfirm)
 */
function TRA_CUSTOM_02_ApproverRejectModal({ open, onClose, onConfirm, title }) {
  const [detail, setDetail] = useState('');
  const [showError, setShowError] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!open) return;
    setDetail('');
    setShowError(false);
    setSubmitting(false);
  }, [open]);

  const handleConfirm = async () => {
    const t = detail.trim();
    if (!t) {
      setShowError(true);
      return;
    }
    setShowError(false);
    setSubmitting(true);
    try {
      await onConfirm?.(t);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={submitting ? undefined : onClose}
      title={
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {title || '결재 반려'}
        </Typography>
      }
      useCloseButton={false}
      useSaveButton={false}
      fullWidth
      maxWidth="sm"
      contentSx={{ pt: 1, pb: 2, px: 2 }}
      content={
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            <UndoIcon color="warning" />
            <Typography variant="body2" color="text.secondary">
              반려 사유를 입력한 뒤 확인을 눌러 주세요. 신청자에게 알림이 전송됩니다.
            </Typography>
          </Box>
          <TextField
            fullWidth
            multiline
            minRows={4}
            maxRows={12}
            placeholder="반려 사유"
            value={detail}
            onChange={(e) => {
              setDetail(e.target.value);
              if (showError && e.target.value.trim()) setShowError(false);
            }}
            error={showError}
            helperText={
              showError
                ? '반려 사유를 입력해 주세요.'
                : `${(detail || '').length}/2000`
            }
            inputProps={{ maxLength: 2000 }}
          />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 1.5,
              mt: 2,
              flexWrap: 'wrap',
            }}
          >
            <Button
              name="취소"
              variant="outlined"
              onClick={onClose}
              disabled={submitting}
              sx={{ minWidth: 88 }}
            />
            <Button
              name="반려 확정"
              variant="contained"
              onClick={handleConfirm}
              disabled={submitting}
              sx={{
                minWidth: 100,
                bgcolor: '#c62828',
                color: '#fff',
                '&:hover': { bgcolor: '#b71c1c' },
              }}
            />
          </Box>
        </Box>
      }
    />
  );
}

export default TRA_CUSTOM_02_ApproverRejectModal;
